// extracted by mini-css-extract-plugin
module.exports = {"bgGradient":"bgGradient___2C5nS"};